import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { API_URL } from './config';
import { NotificationProvider } from './contexts/NotificationContext';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

const Root = (
  <React.StrictMode>
    {POSTHOG_KEY ? (
      <PostHogProvider
        apiKey={POSTHOG_KEY}
        options={{
          api_host: POSTHOG_HOST,
          defaults: '2025-05-24',
          capture_exceptions: true,
          debug: process.env.NODE_ENV === 'development',
        }}
      >
        <NotificationProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </NotificationProvider>
      </PostHogProvider>
    ) : (
      <NotificationProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </NotificationProvider>
    )}
  </React.StrictMode>
);

root.render(Root);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Global error capture to route unhandled errors to backend persistence
window.onerror = function (message, source, lineno, colno, error) {
  try {
    fetch(`${API_URL}/logs/error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        level: 'error',
        message: String(message || 'Unhandled error'),
        stack: error?.stack,
        route: window.location.pathname,
        context: { source, lineno, colno },
      }),
    }).catch(() => {});
  } catch {}
  return false;
};

window.onunhandledrejection = function (event) {
  try {
    const reason: any = event.reason || {};
    fetch(`${API_URL}/logs/error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        level: 'error',
        message: 'Unhandled promise rejection',
        stack: reason?.stack,
        route: window.location.pathname,
        context: { reason },
      }),
    }).catch(() => {});
  } catch {}
};
